import React from 'react';
import { PlayerSummaryCard } from '../components/PlayerSummaryCard';
import { DollarSign, PieChart, TrendingUp } from 'lucide-react';
export function Home() {
  return <div className="p-8 max-w-6xl mx-auto" data-id="element-239">
      <div className="mb-8" data-id="element-240">
        <h1 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-241">
          Welcome to Cashflow Audit Pro
        </h1>
        <p className="text-gray-600" data-id="element-242">
          Your personalized financial audit tool. View the financial summaries
          of all players below.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-10" data-id="element-243">
        <PlayerSummaryCard playerNumber={1} data-id="element-244" />
        <PlayerSummaryCard playerNumber={2} data-id="element-245" />
        <PlayerSummaryCard playerNumber={3} data-id="element-246" />
        <PlayerSummaryCard playerNumber={4} data-id="element-247" />
        <PlayerSummaryCard playerNumber={5} data-id="element-248" />
        <PlayerSummaryCard playerNumber={6} data-id="element-249" />
        <PlayerSummaryCard playerNumber={7} data-id="element-250" />
        <PlayerSummaryCard playerNumber={8} data-id="element-251" />
      </div>
    </div>;
}